const actions = {
  CREATE_SHOP_MENU: 'CREATE_SHOP_MENU',
  CREATE_SHOP_MENU_ENDED: 'CREATE_SHOP_MENU_ENDED',
  SEARCH_SHOP_MENUS: 'SEARCH_SHOP_MENUS',
  SEARCH_SHOP_MENUS_ENDED: 'SEARCH_SHOP_MENUS_ENDED',
  UPDATE_SHOP_MENU: 'UPDATE_SHOP_MENU',
  UPDATE_SHOP_MENU_ENDED: 'UPDATE_SHOP_MENU_ENDED',
  DELETE_SHOP_MENUS: 'DELETE_SHOP_MENUS',
  DELETE_SHOP_MENUS_ENDED: 'DELETE_SHOP_MENUS_ENDED',
  COPY_SHOP_MENU: 'COPY_SHOP_MENU',
  COPY_SHOP_MENU_ENDED: 'COPY_SHOP_MENU_ENDED',
  SEARCH_MERCHANDISES: 'SEARCH_MERCHANDISES',
  SEARCH_MERCHANDISES_END: 'SEARCH_MERCHANDISES_END',
  CREATE_MERCHANDISE: 'CREATE_MERCHANDISE',
  CREATE_MERCHANDISE_END: 'CREATE_MERCHANDISE_END',
  UPDATE_MERCHANDISE: 'UPDATE_MERCHANDISE',
  UPDATE_MERCHANDISE_END: 'UPDATE_MERCHANDISE_END',
  FIND_MERCHANDISE: 'FIND_MERCHANDISE',
  FIND_MERCHANDISE_END: 'FIND_MERCHANDISE_END',
  DELETE_MERCHANDISES: 'DELETE_MERCHANDISES',
  DELETE_MERCHANDISES_END: 'DELETE_MERCHANDISES_END',
  CREATE_SHOP_MENU_SHOP_MERCHANDISES: 'CREATE_SHOP_MENU_SHOP_MERCHANDISES',
  CREATE_SHOP_MENU_SHOP_MERCHANDISES_ENDED: 'CREATE_SHOP_MENU_SHOP_MERCHANDISES_ENDED',
  SEARCH_SHOP_MENU_SHOP_MERCHANDISES: 'SEARCH_SHOP_MENU_SHOP_MERCHANDISES',
  SEARCH_SHOP_MENU_SHOP_MERCHANDISES_ENDED: 'SEARCH_SHOP_MENU_SHOP_MERCHANDISES_ENDED',
  DELETE_SHOP_MENU_SHOP_MERCHANDISES: 'DELETE_SHOP_MENU_SHOP_MERCHANDISES',
  DELETE_SHOP_MENU_SHOP_MERCHANDISES_ENDED: 'DELETE_SHOP_MENU_SHOP_MERCHANDISES_ENDED',
  CREATE_ADDITIONAL_SHOP_MERCHANDISE: 'CREATE_ADDITIONAL_SHOP_MERCHANDISE',
  CREATE_ADDITIONAL_SHOP_MERCHANDISE_ENDED: 'CREATE_ADDITIONAL_SHOP_MERCHANDISE_ENDED',
  SEARCH_ADDITIONAL_SHOP_MERCHANDISES: 'SEARCH_ADDITIONAL_SHOP_MERCHANDISES',
  SEARCH_ADDITIONAL_SHOP_MERCHANDISES_ENDED: 'SEARCH_ADDITIONAL_SHOP_MERCHANDISES_ENDED',
  DELETE_ADDITIONAL_SHOP_MERCHANDISES: 'DELETE_ADDITIONAL_SHOP_MERCHANDISES',
  DELETE_ADDITIONAL_SHOP_MERCHANDISES_ENDED: 'DELETE_ADDITIONAL_SHOP_MERCHANDISES_ENDED',
  SEARCH_SHOP_CATEGORIES: 'SEARCH_SHOP_CATEGORIES',
  SEARCH_SHOP_CATEGORIES_ENDED: 'SEARCH_SHOP_CATEGORIES_ENDED',
  UPDATE_SHOP_CATEGORIES: 'UPDATE_SHOP_CATEGORIES',
  UPDATE_SHOP_CATEGORIES_ENDED: 'UPDATE_SHOP_CATEGORIES_ENDED',
  SEARCH_MERCHANDISE_SPECS: 'SEARCH_MERCHANDISE_SPECS',
  SEARCH_MERCHANDISE_SPECS_END: 'SEARCH_MERCHANDISE_SPECS_END',
  CREATE_MERCHANDISE_SPEC: 'CREATE_MERCHANDISE_SPEC',
  CREATE_MERCHANDISE_SPEC_END: 'CREATE_MERCHANDISE_SPEC_END',
  UPDATE_MERCHANDISE_SPEC: 'UPDATE_MERCHANDISE_SPEC',
  UPDATE_MERCHANDISE_SPEC_END: 'UPDATE_MERCHANDISE_SPEC_END',
  FIND_MERCHANDISE_SPEC: 'FIND_MERCHANDISE_SPEC',
  FIND_MERCHANDISE_SPEC_END: 'FIND_MERCHANDISE_SPEC_END',
  DELETE_MERCHANDISE_SPECS: 'DELETE_MERCHANDISE_SPECS',
  DELETE_MERCHANDISE_SPECS_END: 'DELETE_MERCHANDISE_SPECS_END',
  SEARCH_MERCHANDISE_ITEMS: 'SEARCH_MERCHANDISE_ITEMS',
  SEARCH_MERCHANDISE_ITEMS_END: 'SEARCH_MERCHANDISE_ITEMS_END',
  CREATE_MERCHANDISE_ITEM: 'CREATE_MERCHANDISE_ITEM',
  CREATE_MERCHANDISE_ITEM_END: 'CREATE_MERCHANDISE_ITEM_END',
  UPDATE_MERCHANDISE_ITEM: 'UPDATE_MERCHANDISE_ITEM',
  UPDATE_MERCHANDISE_ITEM_END: 'UPDATE_MERCHANDISE_ITEM_END',
  FIND_MERCHANDISE_ITEM: 'FIND_MERCHANDISE_ITEM',
  FIND_MERCHANDISE_ITEM_END: 'FIND_MERCHANDISE_ITEM_END',
  DELETE_MERCHANDISE_ITEMS: 'DELETE_MERCHANDISE_ITEMS',
  DELETE_MERCHANDISE_ITEMS_END: 'DELETE_MERCHANDISE_ITEMS_END',
  UPDATE_SHOP_MAIN_CONFIGURATION: 'UPDATE_SHOP_MAIN_CONFIGURATION',
  UPDATE_SHOP_MAIN_CONFIGURATION_ENDED: 'UPDATE_SHOP_MAIN_CONFIGURATION_ENDED',
  GET_SHOP_MAIN_CONFIGURATION: 'GET_SHOP_MAIN_CONFIGURATION',
  GET_SHOP_MAIN_CONFIGURATION_ENDED: 'GET_SHOP_MAIN_CONFIGURATION_ENDED',
  UPDATE_SHOP_BRAND_CONFIGURATION: 'UPDATE_SHOP_BRAND_CONFIGURATION',
  UPDATE_SHOP_BRAND_CONFIGURATION_ENDED: 'UPDATE_SHOP_BRAND_CONFIGURATION_ENDED',
  CREATE_SHOP_BRAND_CONFIGURATION: 'CREATE_SHOP_BRAND_CONFIGURATION',
  CREATE_SHOP_BRAND_CONFIGURATION_ENDED: 'CREATE_SHOP_BRAND_CONFIGURATION_ENDED',
  SEARCH_SHOP_BRAND_CONFIGURATIONS: 'SEARCH_SHOP_BRAND_CONFIGURATIONS',
  SEARCH_SHOP_BRAND_CONFIGURATIONS_ENDED: 'SEARCH_SHOP_BRAND_CONFIGURATIONS_ENDED',
  SEARCH_SHOP_ORDERS: 'SEARCH_SHOP_ORDERS',
  SEARCH_SHOP_ORDERS_ENDED: 'SEARCH_SHOP_ORDERS_ENDED',
  SHOP_ORDER_REFUND: 'SHOP_ORDER_REFUND',
  SHOP_ORDER_REFUND_ENDED: 'SHOP_ORDER_REFUND_ENDED',
  SHOP_ORDER_REFUND_BY_MANUALLY: 'SHOP_ORDER_REFUND_BY_MANUALLY',
  SHOP_ORDER_REFUND_BY_MANUALLY_ENDED: 'SHOP_ORDER_REFUND_BY_MANUALLY_ENDED',
  SHOP_ORDER_PARTIALLY_REFUND: 'SHOP_ORDER_PARTIALLY_REFUND',
  SHOP_ORDER_PARTIALLY_REFUND_ENDED: 'SHOP_ORDER_PARTIALLY_REFUND_ENDED',
  CREATE_SHOP_POINT_DISCOUNT_RULE: 'CREATE_SHOP_POINT_DISCOUNT_RULE',
  CREATE_SHOP_POINT_DISCOUNT_RULE_ENDED: 'CREATE_SHOP_POINT_DISCOUNT_RULE_ENDED',
  SEARCH_SHOP_POINT_DISCOUNT_RULES: 'SEARCH_SHOP_POINT_DISCOUNT_RULES',
  SEARCH_SHOP_POINT_DISCOUNT_RULES_ENDED: 'SEARCH_SHOP_POINT_DISCOUNT_RULES_ENDED',
  UPDATE_SHOP_POINT_DISCOUNT_RULE: 'UPDATE_SHOP_POINT_DISCOUNT_RULE',
  UPDATE_SHOP_POINT_DISCOUNT_RULE_ENDED: 'UPDATE_SHOP_POINT_DISCOUNT_RULE_ENDED',
  DELETE_SHOP_POINT_DISCOUNT_RULES: 'DELETE_SHOP_POINT_DISCOUNT_RULES',
  DELETE_SHOP_POINT_DISCOUNT_RULES_ENDED: 'DELETE_SHOP_POINT_DISCOUNT_RULES_ENDED',
  CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY: 'CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY',
  CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED: 'CREATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED',
  UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY: 'UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY',
  UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED: 'UPDATE_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED',
  SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES: 'SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES',
  SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED: 'SEARCH_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED',
  FIND_SCHEDULED_PROMOTIONAL_ACTIVITY: 'FIND_SCHEDULED_PROMOTIONAL_ACTIVITY',
  FIND_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED: 'FIND_SCHEDULED_PROMOTIONAL_ACTIVITY_ENDED',
  DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES: 'DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES',
  DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED: 'DELETE_SCHEDULED_PROMOTIONAL_ACTIVITIES_ENDED',
  CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY: 'CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY',
  CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED:
    'CREATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED',
  UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY: 'UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY',
  UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED:
    'UPDATE_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED',
  SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES: 'SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES',
  SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED:
    'SEARCH_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED',
  FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY: 'FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY',
  FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED: 'FIND_MEMBER_TICKET_PROMOTIONAL_ACTIVITY_ENDED',
  DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES: 'DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES',
  DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED:
    'DELETE_MEMBER_TICKET_PROMOTIONAL_ACTIVITIES_ENDED',
  UPDATE_SHOP_MERCHANDISE_CATEGORY: 'UPDATE_SHOP_MERCHANDISE_CATEGORY',
  UPDATE_SHOP_MERCHANDISE_CATEGORY_ENDED: 'UPDATE_SHOP_MERCHANDISE_CATEGORY_ENDED',
  SEARCH_SHOP_MERCHANDISE_CATEGORIES: 'SEARCH_SHOP_MERCHANDISE_CATEGORIES',
  SEARCH_SHOP_MERCHANDISE_CATEGORIES_ENDED: 'SEARCH_SHOP_MERCHANDISE_CATEGORIES_ENDED',
  FIND_SHOP_MERCHANDISE_CATEGORY: 'FIND_SHOP_MERCHANDISE_CATEGORY',
  FIND_SHOP_MERCHANDISE_CATEGORY_ENDED: 'FIND_SHOP_MERCHANDISE_CATEGORY_ENDED',
  DELETE_SHOP_MERCHANDISE_CATEGORIES: 'DELETE_SHOP_MERCHANDISE_CATEGORIES',
  DELETE_SHOP_MERCHANDISE_CATEGORIES_ENDED: 'DELETE_SHOP_MERCHANDISE_CATEGORIES_ENDED',
  DELETE_SALES_QUANTITY: 'DELETE_SALES_QUANTITY',
  DELETE_SALES_QUANTITY_ENDED: 'DELETE_SALES_QUANTITY_ENDED',
  SEARCH_SALES_QUANTITY: 'SEARCH_SALES_QUANTITY',
  SEARCH_SALES_QUANTITY_ENDED: 'SEARCH_SALES_QUANTITY_ENDED',
  GET_SALES_QUANTITY: 'GET_SALES_QUANTITY',
  GET_SALES_QUANTITY_ENDED: 'GET_SALES_QUANTITY_ENDED',
  CREATE_SALES_QUANTITY: 'CREATE_SALES_QUANTITY',
  CREATE_SALES_QUANTITY_ENDED: 'CREATE_SALES_QUANTITY_ENDED',
  UPDATE_SALES_QUANTITY: 'UPDATE_SALES_QUANTITY',
  UPDATE_SALES_QUANTITY_ENDED: 'UPDATE_SALES_QUANTITY_ENDED',
  RETRY_SHOP_ORDER_REFUND: 'RETRY_SHOP_ORDER_REFUND',
  RETRY_SHOP_ORDER_REFUND_ENDED: 'RETRY_SHOP_ORDER_REFUND_ENDED',
  GET_STORES_IDS_RELATED_TO_SHOP_MENU: 'GET_STORES_IDS_RELATED_TO_SHOP_MENU',
  GET_STORES_IDS_RELATED_TO_SHOP_MENU_ENDED: 'GET_STORES_IDS_RELATED_TO_SHOP_MENU_ENDED',
  SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS: 'SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS',
  SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS_END: 'SEARCH_SHOP_ORDER_EXTRA_COLUMN_KEYS_END',
  UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY: 'UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY',
  UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END: 'UPDATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END',
  CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY: 'CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY',
  CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END: 'CREATE_SHOP_ORDER_EXTRA_COLUMN_KEY_END',
  GET_SHOP_ORDER_EXTRA_COLUMN_KEY: 'GET_SHOP_ORDER_EXTRA_COLUMN_KEY',
  GET_SHOP_ORDER_EXTRA_COLUMN_KEY_END: 'GET_SHOP_ORDER_EXTRA_COLUMN_KEY_END',
  DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY: 'DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY',
  DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY_END: 'DELETE_SHOP_ORDER_EXTRA_COLUMN_KEY_END',
  SEARCH_STORE_CONFIGURATION_SETTINGS: 'SEARCH_STORE_CONFIGURATION_SETTINGS',
  SEARCH_STORE_CONFIGURATION_SETTINGS_ENDED: 'SEARCH_STORE_CONFIGURATION_SETTINGS_ENDED',
  GET_WEEKDAY_SERVICE_SETTINGS: 'GET_WEEKDAY_SERVICE_SETTINGS',
  GET_WEEKDAY_SERVICE_SETTINGS_ENDED: 'GET_WEEKDAY_SERVICE_SETTINGS_ENDED',
  UPDATE_WEEKDAY_SERVICE_SETTING: 'UPDATE_WEEKDAY_SERVICE_SETTING',
  UPDATE_WEEKDAY_SERVICE_SETTING_ENDED: 'UPDATE_WEEKDAY_SERVICE_SETTING_ENDED',
  GET_SUSPEND_SERVICE_SETTING: 'GET_SUSPEND_SERVICE_SETTING',
  GET_SUSPEND_SERVICE_SETTING_ENDED: 'GET_SUSPEND_SERVICE_SETTING_ENDED',
  GET_TODAY_SERVICE_STATUS: 'GET_TODAY_SERVICE_STATUS',
  GET_TODAY_SERVICE_STATUS_ENDED: 'GET_TODAY_SERVICE_STATUS_ENDED',
  UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS: 'UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS',
  UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS_ENDED: 'UPDATE_SHOP_STORE_TODAY_SERVICE_STATUS_ENDED',
  CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING: 'CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING',
  CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED:
    'CREATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED',
  UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING: 'UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING',
  UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED:
    'UPDATE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED',
  DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING: 'DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING',
  DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED:
    'DELETE_SHOP_STORE_SUSPEND_SERVICE_SETTING_ENDED',
  GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS: 'GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS',
  GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED: 'GET_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED',
  DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS: 'DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS',
  DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED:
    'DELETE_SHOP_STORE_HOLIDAY_SERVICE_SETTINGS_ENDED',
  CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING: 'CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING',
  CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED:
    'CREATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED',
  UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING: 'UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING',
  UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED:
    'UPDATE_SHOP_STORE_HOLIDAY_SERVICE_SETTING_ENDED',
  GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING: 'GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING',
  GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED:
    'GET_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED',
  UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING:
    'UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING',
  UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED:
    'UPDATE_SHOP_STORE_REPLENISH_TIME_SERVICE_SETTING_ENDED',
  GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING:
    'GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING',
  GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED:
    'GET_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED',
  UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING:
    'UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING',
  UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED:
    'UPDATE_SHOP_STORE_OVER_MINUTES_TIME_SERVICE_SETTING_ENDED',
  SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS:
    'SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS',
  SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED:
    'SEARCH_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED',
  UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS:
    'UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS',
  UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED:
    'UPDATE_SHOP_STORE_MERCHANDISES_AVAILABLE_STATUS_SETTINGS_ENDED',
  SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS:
    'SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS',
  SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED:
    'SEARCH_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED',
  UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS:
    'UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS',
  UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED:
    'UPDATE_SHOP_STORE_MERCHANDISES_ITEMS_STOCK_STATUS_SETTINGS_ENDED',
  SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS:
    'SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS',
  SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED:
    'SEARCH_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED',
  UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS:
    'UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS',
  UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED:
    'UPDATE_SHOP_STORE_MERCHANDISE_ITEM_SPEC_OPTION_STOCK_SETTINGS_ENDED',
};
export default actions;
